import type { CustomerIoProduct } from "@/features/analytics/models";
import type { CategoryWithSelectedProduct } from "@/features/products/models";
import { CATEGORY_SLUG } from "@/shared/domains";

export const hasWeightLossProduct = (
  products: { productCategory?: CustomerIoProduct["productCategory"] }[],
): boolean =>
  products.some(
    (product) => product.productCategory === CATEGORY_SLUG.WEIGHT_LOSS,
  );

export const categoriesToCustomerIoProducts = (
  categories: CategoryWithSelectedProduct[],
): CustomerIoProduct[] => {
  return categories
    .map((category) => {
      if (!category.selectedProduct?.selectedPrice) {
        return;
      }

      const { subscriptionPriceId, durationInMonths, price } =
        category.selectedProduct.selectedPrice;

      return {
        productId: subscriptionPriceId,
        productCategory: category.slug,
        productName: category.selectedProduct?.name,
        productFrequency: durationInMonths,
        price,
      };
    })
    .filter((product) => !!product);
};
